module.exports = __webpack_public_path__ + "static/media/lili_edited.386b76fb.jpg";